export default "__VITE_ASSET__Bnio5JRi__"